import styles from './ReviewEntryDialog.module.scss'

import type { AdminSharedDictionaryRow } from '@/api/generated'
import Button from '@/components/Button'
import DialogWrapper from '@/components/Dialog'
import { EM_DASH, formatIsoDate, scopeLabel } from '@/pages/app/DictionarySnippets/format'

interface ReviewEntryDialogProps {
  entry: AdminSharedDictionaryRow | null
  requester: string
  isApproving: boolean
  onApprove: () => void
  onReject: () => void
  onClose: () => void
}

const ReviewEntryDialog = ({ entry, requester, isApproving, onApprove, onReject, onClose }: ReviewEntryDialogProps) => {
  if (!entry) return null

  return (
    <DialogWrapper isOpen title={entry.word} close={isApproving ? () => {} : onClose} minWidth={560}>
      <div className={styles.meta}>
        <span className={styles.kind}>{entry.is_snippet ? 'Snippet' : 'Word'}</span>
        <span>{scopeLabel(entry)}</span>
        <span>{requester}</span>
        <span>{formatIsoDate(entry.requested_at)}</span>
      </div>
      {/* Plain text, never `replacement_html`: the admin approves the bytes, not a rendering of them. */}
      <pre className={styles.fullText}>{entry.replacement || EM_DASH}</pre>
      <div className={styles.actions}>
        <Button title="Cancel" type="light" onClick={onClose} isDisabled={isApproving} />
        <Button title="Reject" type="destructiveLight" onClick={onReject} isDisabled={isApproving} />
        <Button title="Approve" type="dark" onClick={onApprove} isLoading={isApproving} isDisabled={isApproving} />
      </div>
    </DialogWrapper>
  )
}

export default ReviewEntryDialog
